angular.module('zc.commonApi')
  .factory('InterestWidgetItem', InterestWidgetItem);

const ITEM_COUNT_THRESHOLD = 5;
const ITEM_AGGREGATION_LIMIT = 5000;

InterestWidgetItem.$inject = ['FacadeV2'];
function InterestWidgetItem(FacadeV2) {
  return { aggregate, aggregateByFilters, rankByFilters };

  function aggregate(paths, params) {
    return FacadeV2.request(
      `/apikeys/${paths.apikey}/interest_widget_items/daily/aggregate`,
      {params}
    )
      .then(res => res.data);
  }

  function aggregateByFilters(apikey, filters, pipeline) {
    return aggregate({ apikey }, {
      match: {
        device: filters.device,
        campaign_segment_id: filters.campaign_segment_id,
        start_at: {
          $gte: moment(filters.start_at).toDate(),
          $lt: moment(filters.end_at).endOf('day').toDate()
        }
      },
      pipeline: pipeline,
      limit: ITEM_AGGREGATION_LIMIT
    });
  }

  function rankByFilters(apikey, filters) {
    return aggregateByFilters(apikey, filters, [{
      $group: {
        _id: '$url',
        thumbnail_url: { $last: '$thumbnail_url' },
        title: { $last: '$title' },
        price: { $last: '$price' },
        item_count: { $sum: '$item_count' },
        iw_item_count: { $sum: '$iw_item_count' }
      }
    }, {
      $match: {
        item_count: { $gte: ITEM_COUNT_THRESHOLD }
      }
    }, {
      $project: {
        _id: 0,
        url: '$_id',
        thumbnail_url: 1,
        title: 1,
        price: 1,
        item_count: 1,
        iw_item_count: 1,
        iw_item_rate: { $divide: [ '$iw_item_count', '$item_count' ] }
      }
    }, {
      $sort: {
        iw_item_rate: -1,
        item_count: -1
      }
    }]);
  }
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/facade/interest_widget_item.service.js